import React from 'react';
import "./webRtcCallStyle.scss";
import "./audio-detection.scss";
import Logo from '../../assets/images/new-images/logoNew.png';
import Timer from '../WebChat/WebCall/Timer';
import { getFormatPhoneNumber, getGridDimensions } from '../../Helpers/Utility';
import SDK from '../../SDK';
import CallControlButtons from './CallControlButtons';
import BigVideo from './BigVideo';
import SmallVideo from './SmallVideo';
import { CALL_STATUS_RECONNECT, CALL_STATUS_DISCONNECTED, CALL_STATUS_CONNECTED, CALL_STATUS_HOLD } from '../../Helpers/Call/Constant';
import { disconnectCallConnection, getCallDisplayDetailsForOnetoManyCall, updateCallTypeAfterCallSwitch } from '../../Helpers/Call/Call';
import { getLocalUserDetails, getUserDetails } from '../../Helpers/Chat/User';
import { getGroupData } from '../../Helpers/Chat/Group';
import _get from "lodash-es/get"
import { BackToChatHoc, 
        ClosePopupHoc, 
        IconInviteHoc, 
        IconParticiantsHoc,
        // TileViewHoc, 
        // TileViewRemoveHoc 
    } from '../../assets/images';
import OutsideClickHandler from 'react-outside-click-handler';
import {deleteItemFromLocalStorage, getFromLocalStorageAndDecrypt} from '../../Helpers/Chat/webChatEncryptDecrypt';
import { useSelector } from 'react-redux';
import { formatUserIdToJid } from '../../Helpers/Chat/ChatHelper';
import  AudioComponent  from './Audio'
import { addShowConfrenceData, updateConfrenceData } from '../../Redux/feature/showConfrenceDataSlice';
import { muteLocalAudio, muteLocalVideo } from '../../callback';
import { addIsMuteListner } from '../../Redux/feature/calllogsDataSlice';
import { store } from '../../Redux/store';
import CallParticipantList from './CallParticipantList';
import { getUsersListFromSDK } from '../WebChat/RecentChatSection/userLists';
import InviteParticipants from './InviteParticipants';
import { hideModal } from '../../Redux/feature/popUpDataSlice';
import { addCallConversion } from '../../Redux/feature/callConversionDataSlice';
import { addCallIntermediate } from '../../Redux/feature/callIntermediateScreenSlice';

let remoteStreamDatas = [];
const WebRtcCall = (props) => {
    const { endCallAction = ()=> {} } = props
    let audio =  window.busySignal;
    // const rosterData = useSelector(state => state.rosterData)
    const showConfrenceData = useSelector(state => state.showConfrenceData?.data)
    const callLogData = useSelector(state => state.callLogData?.data)
    const pinUserData = useSelector(state => state.pinUserData?.data)
    const pinUserJid = pinUserData && pinUserData.userJid;
    const largeVideoUserDataJid = pinUserJid ;
    const addCustomCall = useSelector(state => state.addCustomCall.data)

    const vCardData = getLocalUserDetails()

    const[getWebRtcCall,setWebRtcCall] = React.useState({
        callState: true,
        visible: true,
        localVideoMuted: props?.localVideoMuted,
        isAllUserReconnecting: false,
    })

    const [tileView , setTileView] = React.useState(false)
    const [tileViewStyle,setTileViewStyle] = React.useState({})
    const [fullView,setFullView] = React.useState(false)
    const [participantListPopup,setParticipantListPopup] = React.useState(false)
    const [invite,setInvite]=React.useState(false)
    
    const{
        callState,
        visible,
        // localVideoMuted,
        // isAllUserReconnecting,
    } = getWebRtcCall

    let visibleStateTimer = 0;

    React.useEffect(()=>{
        setTileView(false)
        startTimer();
        window.addEventListener("resize", updateWindowDimensions);
        return () => {
            stopAudio();
            clearTimeout(visibleStateTimer);
        };
    },[])

    React.useEffect(()=>{
        setWebRtcCall({...getWebRtcCall, localVideoMuted: showConfrenceData?.localVideoMuted })
    },[showConfrenceData])

    React.useEffect(()=>{
        let calleStatus = getCallStatus();
        if(calleStatus && calleStatus.toLowerCase() === CALL_STATUS_CONNECTED){
            stopAudio();
        }
        if(calleStatus && calleStatus.toLowerCase() === CALL_STATUS_RECONNECT){
            playReconnectingSound();
        }
    },[showConfrenceData.callStatusText])

    React.useEffect(()=>{
        if (tileView) {
            setTimeout(() => {
                handleGridDimensions();
            }, 100);
        } else {
            setTileViewStyle({});
        }
    },[tileView])

    React.useEffect(()=>{
        if (tileView) {
            setTimeout(() => {
                handleGridDimensions();
            }, 100);
        } else {
            setTileViewStyle({});
        }
    },[props?.showConfrenceDataId])

    const handleGridDimensions = () => {
        const parentElement = document.querySelectorAll('[data-overlap-id="call-thumbnail-view"]');
        let height = parentElement.length > 0 && window.getComputedStyle(parentElement[0], null).getPropertyValue("height");
        height = height && height.replace("px", "");
        const { width, height: newHeight } = getGridDimensions(height, props?.remoteStream?.length)
        setTileViewStyle({
            margin: "5px",
            width: `calc(${width}% - 10px)`,
            height: `calc(${newHeight}px - 0px)`
        });
    }

    const updateWindowDimensions = (event) => {
        if (tileView) handleGridDimensions();
    }

    const startTimer = () => {
        clearTimeout(visibleStateTimer);
        visibleStateTimer = setTimeout(() => {
            setWebRtcCall({ 
                ...getWebRtcCall,
                visible: false }
                );
        }, 5000)
    }

    const handleHideCallScreen = (e) => {
        e.stopPropagation();
        store.dispatch(addCallIntermediate({ show: false }));
        props.hideCallScreen();
    } 

    const handleParticipantListPopup = (e) => {
        e.preventDefault();
        setParticipantListPopup(prevState => (!prevState))
    }
    const handleCloseInvitePeople = () => {
        // setWebRtcCall({ 
        //     ...getWebRtcCall,
        //     invite: false })
        setInvite(false);
        store.dispatch(hideModal());
    }

    const handleVideoFullView = () =>{
        setFullView(prevState=>(!prevState))
        // setWebRtcCall(
        //     {...getWebRtcCall,
        //         fullView:!fullView
        //     }
        // )
    };
    const playReconnectingSound = () => {
        // If current user in reconnecting state, then play the reconnect sound
        playAudio();
    }
   const playAudio=()=> {
        audio.play();
        audio.loop = true;
    }

    const getCallStatus = (userid) => {
        const data = showConfrenceData;
        if (data.callStatusText === CALL_STATUS_DISCONNECTED || data.callStatusText === CALL_STATUS_RECONNECT) return data.callStatusText;
        let vcardData = getLocalUserDetails();
        let currentUser = vcardData.fromUser;
        const remoteStream = props.remoteStream;
        if(!userid){
            userid = formatUserIdToJid(currentUser);
        }
        const user = remoteStream.find(item => item.fromJid === userid);
        return user && user.status;
    }

    const getLargeVideoUserJid = () => {
        const remoteStream = props.remoteStream;
        if (remoteStream && remoteStream.length === 2) {
            let vcardData = getLocalUserDetails();
            let jid = "";
            remoteStream.map((rs,ind) => {
                let id = rs.fromJid;
                id = id.includes("@") ? id.split("@")[0] : id;
                if(id !== vcardData.fromUser){
                    jid = rs.fromJid;
                }
            });
            return jid;
        }
        return largeVideoUserDataJid;

    }
   const handleHangUp = async (e) => {
        await endCall()
    }
    const endCall = async () => {
        stopAudio();
        endCallAction();
        disconnectCallConnection();//hangUp calls
    }
    const stopAudio = () => {
        audio.loop = false;
        audio.pause();
        audio.currentTime = 0;
    }

    const handleAudioMute = async(audioMute) =>{
        const AudioMutecallStatus = getCallStatus();
        if(AudioMutecallStatus && (AudioMutecallStatus.toLowerCase() === CALL_STATUS_CONNECTED || AudioMutecallStatus.toLowerCase() === CALL_STATUS_HOLD)){
            const audioMuteResult = await SDK.muteAudio(audioMute);
            if (audioMuteResult?.statusCode === 200) {
                muteLocalAudio(audioMute);
                store.dispatch(addIsMuteListner(audioMute));
                store.dispatch(addShowConfrenceData({
                    ...showConfrenceData,
                    localAudioMuted: !audioMute
                }));
            }
        }
    }

    const handleVideoMute = async(videoMute) =>{
        const callStatusVideo = getCallStatus();
        if(callStatusVideo && (callStatusVideo.toLowerCase() === CALL_STATUS_CONNECTED || callStatusVideo.toLowerCase() === CALL_STATUS_HOLD)){
            const callConnectionDatas = JSON.parse(getFromLocalStorageAndDecrypt('call_connection_status'));
            const callMode = (callConnectionDatas && callConnectionDatas.callMode) || '';
            const allUsersVideoMuted = await SDK.isAllUsersVideoMuted();
            if (allUsersVideoMuted && callMode === "onetoone") {
                setWebRtcCall({...getWebRtcCall, localVideoMuted: showConfrenceData?.localVideoMuted })
                store.dispatch(addCallConversion({ status: 'request_init' }));
                return;
            }

            const videoMuteResult = await SDK.muteVideo(videoMute);
            if (videoMuteResult?.statusCode === 200) {
                muteLocalVideo(videoMute);
                setWebRtcCall({...getWebRtcCall, localVideoMuted: videoMute })
                if (videoMute) updateCallTypeAfterCallSwitch(videoMute);
                store.dispatch(updateConfrenceData({ ...showConfrenceData, localVideoMuted: videoMute }));
            } else if (videoMuteResult?.statusCode === 500) {
                store.dispatch(addShowConfrenceData({ ...showConfrenceData, videoPermissionDisabled: true }));
            }
        }
    }

    const  renderStream = (streamrosterData) => {
        if (props.localStream && props.remoteStream.length > 1) {
            remoteStreamDatas = [...props.remoteStream];
            const largeVideoStreamUserJid = largeVideoUserDataJid;
            deleteItemFromLocalStorage('connecting');
            let keyFound = 0;
            let callMode = remoteStreamDatas.length > 2 ? 'onetomany' : 'onetoone';
            if (largeVideoStreamUserJid) {
                if (remoteStreamDatas.length > 2) {
                    remoteStreamDatas.forEach((item, key) => {
                        if (largeVideoStreamUserJid === item.fromJid) {
                            keyFound = key;
                        }
                    });
                }
            }
            else{
                if (remoteStreamDatas.length > 2) {
                    remoteStreamDatas.forEach((item, key) => {
                       if(item.stream){
                            keyFound = key;
                       }
                    });
                }
            }
            return renderVideoCallUI(callMode, streamrosterData, keyFound);
        } else {
            return <></>;
        }
    }
    const isThumbnailViewOverlapFunc = () => {
        const controllButton = document.querySelectorAll('[data-overlap-id="call-controll-buttons"]');
        const thumbView = document.querySelectorAll('[data-overlap-id="call-thumbnail-view"]');
        const thumbViewLocalUser = document.querySelectorAll('[data-overlap-id="call-thumbnail-view-local"]');
        if (!controllButton ||
            (!controllButton[0]) ||
            ((!thumbView || (!thumbView[0])) && (!thumbViewLocalUser || (!thumbViewLocalUser[0])))
        ) return true;
    
        const controllButtonPos = (isNaN(controllButton[0].offsetLeft) ? 0 : controllButton[0].offsetLeft) + 100;
        let thumbViewPos = 0;
        let thumbViewLocalUserPos = 0;
        if (thumbView && thumbView[0]) {
            thumbViewPos = isNaN(thumbView[0].offsetLeft) ? thumbViewPos : thumbView[0].offsetLeft;
        }
        if (thumbViewLocalUser && thumbViewLocalUser[0]) {
            thumbViewLocalUserPos = isNaN(thumbViewLocalUser[0].offsetLeft) ? thumbViewLocalUserPos : thumbViewLocalUser[0].offsetLeft;
        }
        return controllButtonPos > 0 && ((thumbViewPos > 0 && thumbViewPos <= controllButtonPos) || (thumbViewLocalUserPos > 0 && thumbViewLocalUserPos <= controllButtonPos));
    }

    const handleMouseMove = () => {
        if (!visible) {
            setWebRtcCall({
                ...getWebRtcCall,
                visible: true });
            startTimer();
        }
    }

    const handleInvitePeople = () => {
        const callStatusInvite = getCallStatus();
        getUsersListFromSDK(1,"");

        if(callStatusInvite && (callStatusInvite.toLowerCase() === CALL_STATUS_CONNECTED || callStatusInvite.toLowerCase() === CALL_STATUS_HOLD)){
            setInvite(prevState => (!prevState))
        }
    }

    /**
        const handleTileView = () => {
            setTileView(prevState => (!prevState))
            setWebRtcCall({
                ...getWebRtcCall,
                tileView: !tileView
            });
        }
    */

    const hanldeOnClick = () => {
        if (!visible) {
            startTimer();
        }
        setWebRtcCall({ 
            ...getWebRtcCall,
            visible: !visible })
    }


    const getGroupDetails = (groupId) => {
        let rosterDataGD = {};
        let group = getGroupData(groupId);
        rosterDataGD.displayName = group.groupName;
        rosterDataGD.image = group.groupImage;
        rosterDataGD.thumbImage = group.thumbImage;
        rosterDataGD.jid = group.groupId;
        rosterDataGD.chatType = "groupchat";
        return rosterDataGD;
    }
    
    const renderVideoCallUI = (callMode, rosterDataVideoCall, keyFound) => {
        let remoteAudioMuted = {...props.remoteAudioMuted};
        let remoteVideoMuted = {...props.remoteVideoMuted};
        let volumeLevel = props.volumeLevel;
        let volumeVideo = props.volumeLevelVideo;
        let showVoiceDetect = props.showVoiceDetect;
        let vcardData =  getLocalUserDetails();
        const isThumbnailViewOverlap = isThumbnailViewOverlapFunc();
        let videoWrapperClass = "RemoteVideo-wrapper";
        if (visible) {
            videoWrapperClass = `${videoWrapperClass} visible`;
            videoWrapperClass = isThumbnailViewOverlap ? `${videoWrapperClass} top` : videoWrapperClass;
        }
        let stream = null;
        let fromJid = null;
        let callStatusVideoCall = null;
        let inverse = false;
        let remoteStream = null;
        let pinUser = remoteStreamDatas.length > 2 ? true : false;
        if(callMode === "onetoone"){
            remoteStreamDatas.forEach((rs,keys) => {
                let id = rs.fromJid;
                id = id.includes("@") ? id.split("@")[0] : id;
                if(id !== vcardData.fromUser){
                    remoteStream = rs;
                }
            });
            callStatusVideoCall = getCallStatus(remoteStream.fromJid);
            stream = remoteStream.stream;
            fromJid = remoteStream.fromJid;
        } else {
            fromJid = remoteStreamDatas[keyFound].fromJid;
            let anotherUserVideoCall = fromJid.includes("@") ? fromJid.split('@')[0] : fromJid;
            let largeVideoUserJidVideoCall = largeVideoUserDataJid || "";
            largeVideoUserJidVideoCall = largeVideoUserJidVideoCall.includes("@") ? largeVideoUserJidVideoCall.split('@')[0] : largeVideoUserJidVideoCall
            if(largeVideoUserJidVideoCall === vcardData.fromUser){
                rosterDataVideoCall = getUserDetails(largeVideoUserJidVideoCall);
                stream = props.localStream;
                inverse = true;
                remoteVideoMuted[fromJid] = props.localVideoMuted;
            } else {
                rosterDataVideoCall = getUserDetails(anotherUserVideoCall);
                stream = remoteStreamDatas[keyFound].stream;
            }
            callStatusVideoCall = getCallStatus(fromJid);
        }
        
        return (
            <>
                {!tileView && <BigVideo
                    key={fromJid}
                    videoMuted={remoteVideoMuted[fromJid] ? remoteVideoMuted[fromJid] : false}
                    audioMuted={remoteAudioMuted[fromJid] ? remoteAudioMuted[fromJid] : false}
                    stream={stream}
                    rosterData={rosterDataVideoCall}
                    jid={fromJid}
                    showConfrenceDataId={props.showConfrenceDataId}
                    remoteStreamLength={remoteStreamDatas.length}
                    callStatus={callStatusVideoCall}
                    volumeLevel={volumeLevel}
                    volumeVideo={volumeVideo}
                    showVoiceDetect={showVoiceDetect}
                    inverse={inverse}
                    handleVideoFullView={handleVideoFullView}
                    pinUserJid={props.pinUserJid}
                    setPinUser={pinUser}
                />}
                {(callMode === "onetoone") && remoteStream && remoteStream.stream && remoteStream.stream.audio && <AudioComponent stream={remoteStream.stream.audio} id={remoteStream.stream.audio.id} muted={false}/>}
                <div className={videoWrapperClass}>
                    <div data-overlap-id="call-thumbnail-view" className="RemoteVideo-list">
                        {(callMode === "onetomany" || tileView) && renderVideoStreamMulti(pinUser)}
                        {renderLocalVideoStream(pinUser)}
                    </div>
                </div>
            </>
        );
    } 

    const renderVideoStreamMulti = (pinUser) => {
        let pinuser = false;
        let remoteStreams = [...remoteStreamDatas];
        let remoteAudioMuted = props.remoteAudioMuted;
        let remoteVideoMuted = props.remoteVideoMuted;
        let vcardData = getLocalUserDetails();
        if (_get(remoteStreams,"length",0) > 0) {
            return remoteStreams.map((remoteStream, index) => {
                let id = remoteStream.fromJid;
                id = id.includes("@") ? id.split("@")[0] : id;
                if(id !== vcardData.fromUser){
                    let stream = remoteStream.stream;
                    if(!stream) {
                        stream = {
                            id: null,
                            audio: null,
                            video: null
                        };
                    }
                    let fromJid = remoteStream.fromJid;
                    let anotherUserVideoStreamMulti = fromJid.includes("@") ? fromJid.split('@')[0] : fromJid;
                    let rosterDataVideoStreamMulti = getUserDetails(anotherUserVideoStreamMulti);
                    let callStatusVideoStreamMulti = "";

                    const data = (showConfrenceData) || {};
                    if (data.callStatusText === CALL_STATUS_DISCONNECTED || data.callStatusText === CALL_STATUS_RECONNECT) {
                        callStatusVideoStreamMulti = data.callStatusText;
                    } else {
                        callStatusVideoStreamMulti = remoteStream.status;
                    }

                    if(pinUser && callStatusVideoStreamMulti){
                        callStatusVideoStreamMulti = callStatusVideoStreamMulti.toLowerCase();
                        if(callStatusVideoStreamMulti === CALL_STATUS_CONNECTED || callStatusVideoStreamMulti === CALL_STATUS_RECONNECT || callStatusVideoStreamMulti === CALL_STATUS_HOLD || callStatusVideoStreamMulti === CALL_STATUS_DISCONNECTED){
                            pinuser = true;
                        } else {
                            pinuser = false;
                        }
                    }

                    let videoMuted = remoteVideoMuted[remoteStream.fromJid] ? remoteVideoMuted[remoteStream.fromJid] : false, 
                        audioMuted = remoteAudioMuted[remoteStream.fromJid] ? remoteAudioMuted[remoteStream.fromJid] : false;
                    if (id === vCardData.fromUser && tileView) {
                        const {  callAudioMute:callAudioMuteVideoStreamMulti = false } = callLogData;
                        stream = props.localStream;
                        videoMuted = props.localVideoMuted;
                        audioMuted = callAudioMuteVideoStreamMulti;
                    }
                    
                    let videoTrackId = stream?.video?.getVideoTracks().length > 0 ? stream?.video?.getVideoTracks()[0].id : "";
                    let audioTrackId = stream?.audio?.getAudioTracks().length > 0 ? stream?.audio?.getAudioTracks()[0].id : "";
                    return (
                        <SmallVideo
                            key={`${fromJid}`}
                            videoMuted={videoMuted}
                            audioMuted={audioMuted}
                            stream={stream}
                            rosterData={rosterDataVideoStreamMulti}
                            jid={fromJid}
                            showConfrenceDataId={props.showConfrenceDataId}
                            pinUserJid={props.pinUserJid}
                            setPinUser={pinuser}
                            callStatus={callStatusVideoStreamMulti}
                            userStatus={remoteStream.status}
                            inverse={false}
                            usersCount={remoteStreams.length}
                            tileView={tileView}
                            tileViewStyle={tileViewStyle}
                            videoTrackId={videoTrackId}
                            audioTrackId={audioTrackId}
                        />
                    )
                } else {
                    return <></>;
                }
            });
        }
        return <></>;
    }

    const renderPartipantsPopup = () => {
        let vcardData = getLocalUserDetails();
        let remoteAudioMuted = props.remoteAudioMuted;
        let remoteVideoMuted = props.remoteVideoMuted;
        const currentUserData = remoteStreamDatas.filter((e) => {
            let id = e.fromJid;
            id = id.includes("@") ? id.split("@")[0] : id;
            if(id === vcardData.fromUser){
                return e;
            }
        });
        const otherUsersData = remoteStreamDatas.map((e,ky) => {
            let id = e.fromJid;
            id = id.includes("@") ? id.split("@")[0] : id;
            if(id !== vcardData.fromUser){
                return e;
            }
            return undefined;
        }).filter((undefinedRemove) => undefinedRemove !== undefined);
        const totalUsersData = [...otherUsersData, ...currentUserData];
        return totalUsersData.map((rs,indexes) => {
            let id = rs.fromJid;
            id = id.includes("@") ? id.split("@")[0] : id;
            let rosterDataUsersData = getUserDetails(id);
            let audioMuted = false;
            let videoMuted = false;
            if(id === vcardData.fromUser){
                rosterDataUsersData.displayName = "You";
                audioMuted = callLogData?.callAudioMute;
                videoMuted = props.localVideoMuted;
            } else {
                audioMuted = remoteAudioMuted[rs.fromJid];
                videoMuted = remoteVideoMuted[rs.fromJid];
            }
            return <CallParticipantList
                key={rs.fromJid}
                userStatus={getCallStatus(rs.fromJid)}
                name={rosterDataUsersData.displayName}
                initialName={rosterDataUsersData.initialName}
                imageUrl={rosterDataUsersData.thumbImage !== "" ? rosterDataUsersData.thumbImage : rosterDataUsersData.image}
                roster={rosterDataUsersData}
                audioMuted={audioMuted}
                videoMuted={videoMuted}
            />
        });
    }

    const handleListPopupClose = () => {
        setParticipantListPopup(false);
    }

    const renderLocalVideoStream = (pinUser) => {
        const callAudioMuteLocalVideoStream = callLogData?.callAudioMute
        let stream = props.localStream;
        let vcardData = {...vCardData};
        vcardData.nickname = "You";
        let fromUser = vcardData.fromUser;
        fromUser =  fromUser.includes("@") ? fromUser : formatUserIdToJid(fromUser);
        const callStatusLocalVideoStream = getCallStatus();
        let videoTrackId = stream?.video?.getVideoTracks().length > 0 ? stream?.video?.getVideoTracks()[0].id : "";
        let audioTrackId = stream?.audio?.getAudioTracks().length > 0 ? stream?.audio?.getAudioTracks()[0].id : "";

        return (
            <SmallVideo
                elKey={`local-user-video-${vcardData.fromUser}`}
                videoMuted={showConfrenceData?.localVideoMuted}
                audioMuted={callAudioMuteLocalVideoStream}
                stream={stream}
                rosterData={vcardData}
                jid={fromUser}
                showConfrenceDataId={props.showConfrenceDataId}
                pinUserJid={props.pinUserJid}
                setPinUser={pinUser}
                callStatus={callStatusLocalVideoStream}
                inverse={true}
                usersCount={remoteStreamDatas.length}
                tileView={tileView}
                tileViewStyle={tileViewStyle}
                videoTrackId={videoTrackId}
                audioTrackId={audioTrackId}
            />
        )
    }

    let anotherUser = "";
    let rosterData = {};
    const callConnectionData = JSON.parse(getFromLocalStorageAndDecrypt('call_connection_status'))
    const largeVideoUserJid = getLargeVideoUserJid();
    let groupDetails = null;
    let audioControl = true;
    let videoControl = true;
    const callStatus = getCallStatus(largeVideoUserJid);
    anotherUser = callConnectionData.from;
    if (callConnectionData.from && callConnectionData.from.includes("@") ? callConnectionData.from.split('@')[0] : callConnectionData.from === vCardData.fromUser) {
        anotherUser = callConnectionData.to;
    }
    if (callConnectionData.callMode === "onetoone") {
        anotherUser = largeVideoUserJid || anotherUser;
        rosterData = getUserDetails(anotherUser);
    } 
    if (callConnectionData.callMode === "onetomany") {
            let user = callConnectionData.groupId !== undefined && callConnectionData.groupId !== null ? callConnectionData.groupId : callConnectionData.from;
            if (callConnectionData.groupId) {
                groupDetails = getGroupDetails(user);
                rosterData = getUserDetails(largeVideoUserJid);
            } else {
                if (props.remoteStream?.length) {
                    let usersList = props.remoteStream.map((item, key) =>  item.fromJid);
                    rosterData = getCallDisplayDetailsForOnetoManyCall(usersList);
                } else {
                    rosterData = getUserDetails(largeVideoUserJid);
                }
            }
        }
    const { showConfrenceData: { data: { videoPermissionDisabled = false } = {}} = {} } = props;
    const callAudioMute = callLogData?.callAudioMute;

    return(
        <>
            {callState &&
                <div 
                    className={`CallingScreenWrapper fit-layout ${tileView ? "tileView" : "group-video-call"} `} 
                    onMouseMove={handleMouseMove} 
                    onClick={hanldeOnClick}
                    id="webrtc-call-screen"
                    >
                    <div className={visible ? "subject visible" : "subject"}>
                        <div style={{visibility:"hidden"}} className="logosm">
                            <img src={Logo} alt="Logo" />
                        </div>
                        {groupDetails ? 
                            <span className="meeting-type-text">
                            {groupDetails.displayName ? groupDetails.displayName : getFormatPhoneNumber(callConnectionData.from)}
                            </span>
                            :
                            <span className="meeting-type-text">{rosterData.displayName ? rosterData.displayName : getFormatPhoneNumber(callConnectionData.from)}</span>  
                        } 
                        <span className="subject-conference-timer">
                            <Timer callStatus={callStatus}/>
                        </span>
                    </div>
                    <div className={visible ? "optionButton visible" : "optionButton"}>
                        {!addCustomCall && 
                            <div>
                                <span title="Back to chat" className="BackToChat" onClick={handleHideCallScreen}>
                                    <i className="backIcon"><span className="toggleAnimation"></span><BackToChatHoc /></i>
                                </span>
                            </div>
                        }
                        <div className="optionBtnGroup">
                            {/* <span
                                className={`${callStatus && callStatus.toLowerCase() === CALL_STATUS_RECONNECT ? "disabled-btn" : ""}${
                                    !tileView ? " tileViewRemove " : " tileView "
                                } `}
                                title="Toggle tile view"
                                >
                                <i className="tileView" onClick={handleTileView}>
                                    <span className="toggleAnimation"></span>
                                    {!tileView ? <TileViewHoc viewBox="0 0 29 29" /> : <TileViewRemoveHoc viewBox="0 0 29 29" />}
                                </i>
                            </span> */}

                            {callStatus && callStatus.toLowerCase() !== CALL_STATUS_DISCONNECTED && remoteStreamDatas.length > 2 && 
                                <OutsideClickHandler
                                    onOutsideClick={() => {
                                        setParticipantListPopup(false)
                                    }}>
                                    <span className="participant-list" title="">
                                        <i className="invite" onClick={(e) => handleParticipantListPopup(e)}>
                                            <span className="count-badge">{remoteStreamDatas.length}</span>
                                            <IconParticiantsHoc viewBox=" 0 0 26.7 23.076"/>
                                        </i>
                                        {participantListPopup && 
                                            <div className="CallParticipantList">
                                                <div className="participant-popup">
                                                    <div className="header">
                                                    <i onClick={()=> handleListPopupClose}>
                                                        <ClosePopupHoc />
                                                    </i>
                                                    <h5>Participants</h5>
                                                    </div>
                                                    <div className="body">
                                                        <ul>
                                                            {renderPartipantsPopup()}
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>                                           
                                        } 
                                    </span>
                                </OutsideClickHandler>
                            }
                            {callStatus && callStatus.toLowerCase() !== CALL_STATUS_DISCONNECTED &&
                            <span className={callStatus && callStatus.toLowerCase() === CALL_STATUS_RECONNECT ?
                                "invitePeople disabled-btn" : "invitePeople"} title="">
                                <i className="invite" onClick={handleInvitePeople}>
                                    <span className="toggleAnimation"></span>
                                    <IconInviteHoc/>
                                </i>
                            </span>                                    
                            }   
                        </div>
                    </div>
                    <div className={`${fullView ? "fullView" : ""} content-body`}>
                        {renderStream(rosterData)}               
                    </div>
                    <div data-overlap-id="call-controll-buttons" className={visible ? "button-group visible" : "button-group"}> 
                        <CallControlButtons
                            cssClassName={callStatus && callStatus.toLowerCase() === CALL_STATUS_RECONNECT ? "disabled-btn" : ""}
                            videoMute={showConfrenceData?.localVideoMuted}
                            audioMute={callAudioMute}
                            handleEndCall={handleHangUp}
                            handleAudioMute={handleAudioMute}
                            handleVideoMute={handleVideoMute}
                            audioControl={audioControl}
                            videoControl={videoControl}
                            videoPermissionDisabled={videoPermissionDisabled}
                        />
                    </div> 
                    {invite && <InviteParticipants remoteStream={props.remoteStream} invite={invite} closePopup={handleCloseInvitePeople}/>}
                </div>
            }
        
        </>
    )
}


export default WebRtcCall;